import {
    CLEAR_DECONNEXION,
    SET_AUTH,
    SET_LOGIN,
    SET_LOGIN_CIN,
    TOKEN_EXPIRED
} from "../../actions/api";
import Cookies from "js-cookie";

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        // case SET_AUTH:
        //case SET_LOGIN:
        case SET_LOGIN_CIN:
            if (
                action?.payload?.success &&
                action?.payload?.token &&
                action?.payload?.profil
            ) {
                return {
                    ...state,
                    authenticated: true,
                    info: action.payload
                };
            }
            return state;

        // case SET_VERIFY_TOKEN:
        //     if (action.payload && action.payload.success) {
        //         return {
        //             ...state,
        //             authenticated: true,
        //             info: action.payload
        //         };
        //     }
        //     return state;
        case TOKEN_EXPIRED:
        case CLEAR_DECONNEXION:
            localStorage.clear();
            document.cookie =
                "session_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie =
                "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            //console.log("initial", initialState);
            //Cookies.expire("authToken");
            return initialState;
        default:
            return state;
    }
};
